import { render, staticRenderFns } from "./asideBar.vue?vue&type=template&id=35209900&scoped=true"
import script from "./asideBar.vue?vue&type=script&lang=js"
export * from "./asideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35209900",
  null
  
)

export default component.exports